import {useState} from 'react';
import {motion, AnimatePresence} from 'framer-motion';
import clsx from 'clsx';

import type {SanityModuleDropdowns} from '../../types';

import ModuleWrapper from './ModuleWrapper.client';
import PortableText from '../portableText/PortableText.client';

const Accordion = ({i, expanded, setExpanded, heading, copy}: any) => {
  const isOpen = i === expanded;
  return (
    <>
      <motion.div
        className={`text-teal flex cursor-pointer flex-row items-center justify-between gap-x-12 border-t border-dark-grey border-opacity-50 py-6 md:py-10`}
        initial={false}
        onClick={() => setExpanded(isOpen ? false : i)}
      >
        <h6 className="richH6 font-bold">{heading}</h6>
        <button aria-label={heading}>
          <svg
            className={clsx(['transition-standard', isOpen && 'rotate-45'])}
            width="20"
            height="20"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className="transition-standard"
              d="M13 0C12.2238 0 11.5947 0.629119 11.5947 1.40531V11.5947H1.40531C0.629119 11.5947 0 12.2238 0 13C0 13.7762 0.629119 14.4053 1.40531 14.4053H11.5947V24.5947C11.5947 25.3709 12.2238 26 13 26C13.7762 26 14.4053 25.3709 14.4053 24.5947V14.4053H24.5947C25.3709 14.4053 26 13.7762 26 13C26 12.2238 25.3709 11.5947 24.5947 11.5947H14.4053V1.40531C14.4053 0.629119 13.7762 0 13 0Z"
              fill={isOpen ? '#F27021' : '#4D4D4F'}
            />
          </svg>
        </button>
      </motion.div>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.section
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: {opacity: 1, height: 'auto'},
              collapsed: {opacity: 0, height: 0},
            }}
            transition={{duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98]}}
          >
            <motion.div
              variants={{
                collapsed: {opacity: 0, scale: 1},
                open: {opacity: 1, scale: 1},
              }}
              transition={{duration: 0.8}}
              className="pb-6 md:pb-10"
            >
              <PortableText blocks={copy} />
            </motion.div>
          </motion.section>
        )}
      </AnimatePresence>
    </>
  );
};

export default function DropdownsModule({
  module,
}: {
  module: SanityModuleDropdowns;
}) {
  const {config, items}: any = module;
  const [expanded, setExpanded] = useState(0);

  return (
    <ModuleWrapper {...config} className="grid grid-cols-14">
      <div className="col-start-2 col-end-14 md:col-start-3 md:col-end-13">
        {items.map((row: any, i: number) => (
          <Accordion
            key={i}
            i={i}
            expanded={expanded}
            setExpanded={setExpanded}
            {...row}
          />
        ))}
      </div>
    </ModuleWrapper>
  );
}
